import type { ChiefAnnotationsNotice } from "../../api/types";
import { t } from "../../i18n/i18n";
import { plural } from "../../plural";

/** Annotations reprises du chef (cascade vers les échelons subordonnés, 15/10/2026) : quand le chef en pose, en
 *  déplace, en modifie ou en supprime, le dossier subordonné suit et en est prévenu : l'avis paraît une fois sur ce
 *  poste à l'ouverture de la carte, et le panneau Annotations rappelle le dernier changement. */

/** « 1 ajoutée, 2 déplacées » : changements comptés, dans l'ordre ; vide sans changement. */
export function chiefChanges(notice: ChiefAnnotationsNotice): string {
  const parts: string[] = [];
  if (notice.added) parts.push(plural(notice.added, t("ajoutée"), t("ajoutées")));
  if (notice.moved) parts.push(plural(notice.moved, t("déplacée"), t("déplacées")));
  if (notice.changed) parts.push(plural(notice.changed, t("modifiée"), t("modifiées")));
  if (notice.removed) parts.push(plural(notice.removed, t("retirée"), t("retirées")));
  return parts.join(", ");
}

/** Titre de l'avis : « L'échelon supérieur (1erRTEST) a modifié ses annotations ». */
export function chiefTitle(notice: ChiefAnnotationsNotice): string {
  return notice.issuer
    ? t("L'échelon supérieur ({unit}) a modifié ses annotations", { unit: notice.issuer })
    : t("L'échelon supérieur a modifié ses annotations");
}

const KEY = "gx.chiefAnnotations.";

/** L'avis `notice` du dossier a-t-il déjà été vu sur ce poste ? (Stockage indisponible : jamais vu.) */
export function chiefNoticeSeen(exerciseId: string, notice: ChiefAnnotationsNotice): boolean {
  try {
    return window.localStorage.getItem(KEY + exerciseId) === notice.at;
  } catch {
    return false;
  }
}

/** Avis marqué vu sur ce poste. */
export function markChiefNoticeSeen(exerciseId: string, notice: ChiefAnnotationsNotice): void {
  try {
    window.localStorage.setItem(KEY + exerciseId, notice.at);
  } catch {
    // Stockage indisponible (navigation privée) : l'avis reparaîtra, sans autre conséquence.
  }
}
